import { X } from 'lucide-react';
import { BliksyIcon, cn } from '@bliks-io/ui';

interface BliksyChatHeaderProps {
  onClose: () => void;
  className?: string;
}

/**
 * Header for the Bliksy chat panel
 * Contains the Bliksy title and close button
 */
export function BliksyChatHeader({ onClose, className }: BliksyChatHeaderProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between border-b border-border bg-white px-4 py-3',
        className
      )}
    >
      <div className="flex items-center gap-2">
        <BliksyIcon size={28} />
        <span className="text-lg font-semibold">Bliksy</span>
      </div>

      <button
        type="button"
        onClick={onClose}
        className={cn(
          'flex h-8 w-8 items-center justify-center rounded-md',
          'text-muted-foreground hover:bg-muted hover:text-foreground',
          'transition-colors'
        )}
        aria-label="Close chat"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
